import * as types from "./types";
import { Commit } from "vuex";
import {
	checkConfirmationCodeAxios,
	increaseAttemptsAxios,
	registrationAxios,
} from "@/store/registration/services";

/**
 * Регистрация
 * @param commit
 * @param payload
 */
export async function registrationAction(
	{ commit }: { commit: Commit },
	payload: {
		phone: string;
	}
): Promise<void> {
	try {
		const { data } = await registrationAxios(payload);

		commit(types.REGISTRATION, data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Проверка кода подтверждения
 * @param commit
 * @param payload
 */
export async function checkConfirmationCodeAction(
	{ commit }: { commit: Commit },
	payload: {
		code: string;
		phone: string;
		action: string;
	}
): Promise<void> {
	try {
		const { data } = await checkConfirmationCodeAxios(payload);

		commit(types.CONFIRMATION_CODE, data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Увеличить количество попыток (attempts)
 * @param commit
 * @param payload
 */
export async function increaseAttemptsAction(
	{ commit }: { commit: Commit },
	payload: {
		phone: string;
		action: string;
	}
): Promise<void> {
	try {
		const { data } = await increaseAttemptsAxios(payload);

		commit(types.INCREASE_ATTEMPTS, data);
	} catch (e) {
		console.log(e);
	}
}

/**
 * Номер телефона
 * @param commit
 * @param payload
 */
export function phoneNumberAction(
	{ commit }: { commit: Commit },
	payload: { phone: string; actionType: string }
): void {
	try {
		commit(types.PHONE_NUMBER, payload);
	} catch (e) {
		console.log(e);
	}
}
